module.exports = __webpack_public_path__ + "img/trash.9b2f449d.svg";